import Store from "$common/utils/store";

let ___languageSsrConfig = {};
try {
  //  将后端渲染的东西序列化成对象
  ___languageSsrConfig = JSON.parse(decodeURIComponent(window.ssrConfig));
} catch (err) {
}
const pageHeader = ___languageSsrConfig?.routerConfig?.pageHeader ?? {
  'accept-language': navigator.language
};
const subLanguage = str => {
  if (!str) {
    return 'en-US'
  }
  str = str.substring(0, 2)
  let obj = {
    en: 'en-US',
    km: 'km-KH',
    zh: 'zh-CN'
  }
  console.log('语种' + obj[str])
  return obj[str]
  // return obj['km']
}
export default {
  getPageHeaderCurrentLanguage: subLanguage(
      Store.loadObject('locale') ||
      pageHeader &&
      pageHeader['accept-language'] ||
      navigator?.language || 'en'
  )
}
